import React from 'react';
import { Link } from 'react-router-dom';
import Seo from '../components/Seo';

function NotFound() {
  return (
    <div className="page page--narrow">
      <Seo title="Página no encontrada" />
      <h1>Parece que esta página se ha perdido entre capítulos.</h1>
      <p>
        <Link to="/">Volver al inicio</Link> · <Link to="/resenas">Ver últimas reseñas</Link> ·{' '}
        <Link to="/buscar">Buscar un libro</Link>
      </p>
    </div>
  );
}

export default NotFound;
